import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import paymentsEsCL from './locales/es-CL.json';
import paymentsEnUS from './locales/en-US.json';
import paymentsPtBR from './locales/pt-BR.json';

export const paymentsI18n = buildScopedI18n({
  esCL: paymentsEsCL,
  enUS: paymentsEnUS,
  ptBR: paymentsPtBR,
});
